import data from './data.js';
export default {
    data() {
        return {
            paymentLoading: false,
            isPaymentDisabled: true,
            isShowLoading: true,
            loading: true,
            isPrintIf: true,
            details: {},
            payResult: {},
            balance: '',
            zfNumber: '',
            substr6: '',
            substr5: '',
            collectLists: [],
            refundLists: [],
            dataId: '',
            businessId: '',
            dataUrl: '',
            status: '',
            supCashNo: '',
            supCode: '',
            supName: '',
            fileId: '',
            fileName: '',
            dataLis: {
                ledgerId: '',
                companyCode: '',
                siteCode: '',
                supCode: '',
                failTime: '',
                dataJobId: '',
                companyName: '',
                supName: ''
            },
            refundList: {
                companyCode: '',
                siteCode: '',
                supCode: '',
                suppliersCode: ''
            },
            data,
            activeName: 'first',
            paymentShow: false,
            refundShow: false,
            isShow: true,
            isPayment: false,
            isRefund: false,
            infoData: {},
            dataPayLists: {
                budgetAmt: '',
                companyCode: '',
                siteCode: '',
                suppCode: '',
                jobId: '',
                currencyCode: '',
                ledgerId: ''
            },
            dataBalanceObj: {
                suppCode: '',
                ledgerId: ''
            },
            isContractName: true,
            applyAmt: '',
            applyNoObj: '',
            ledgerId: '',
            deid: '',
            accountCode: '',
            contract: '',
            contractStatus: '',
            mdcoContractNo: '',
            suppliersCode: '',
            companyCode: '',
            companyName: '',
            siteCode: '',
            applicationForPaymentModel: [],
            depositTransfer: [],
            receivableTransferDepositModel: [],
            dataObjPDF: {
                ledgerName: '', // 会计主体名称
                theReturnAmt: '', // 金额为供应商申请的金额
                balanceAmt: '', // 押金余额
                amtBalan: '', // 退款申请余额
                supplierName: '', // 合同名称
                mdcoContractNo: '', // 合同编号(待定)
                receiptNumber: '', // 收据编号 (待定)
                bankName: '', // 开户名称
                uBankNo: '', // 开户行号
                bankAccount: '', // 银行账号
                bankAccountName: '' // 开户银行
            }
        };
    }
};
